import { useContext } from 'react';

import { ToastStateContext } from './context.ts';
import { type ToastState } from './types.ts';

function useToastState(): ToastState {
    const state = useContext(ToastStateContext);

    return state;
}

export { useToastState };
